import React from "react";
import {
	ArrowLeftOutlined,
	CloseOutlined,
	CloseCircleOutlined,
	PaperClipOutlined,
	PlusOutlined
} from "@ant-design/icons";
import { t } from "i18next";
import moment from "moment";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import {
	Tag,
	InputDate,
	InputText,
	NumberInput,
	Form,
	Button,
	Col,
	Card,
	Row,
	Select,
	SelectInput,
	Checkbox,
	Input,
	Table,
	Divider,
	Upload,
	Steps,
	Result
} from "common/elements";
import {
	insertNewRecord,
	getFormPayload,
} from "services/employee";
import { getAllowances } from "services/payroll_item";
import { getNSSF } from "services/nssf";
import { getHostURl, getURl } from "services/core";
import { Util } from "common/util";
import Enum from "common/enums";
import "./form.css";
import { getMany } from "services/project";

const { Dragger } = Upload;

class CreateNew extends React.PureComponent {
	state = {
		loadingButton: false,
		id: null,
		formData: {
			gender: 0,
		},
		nssf: {},
		errorFields: [],
		currentStep: 0,
		requiredContractEndDate: false,
		requiredNoticePeriodType: false,
		requiredLastWorkingDay: false,
		projects: [],
		departments: [],
		dutyStations: [],
		fifthLineManagers: [],
		fourthLineManagers: [],
		thirdLineManagers: [],
		supervisors: [],
		teams: [],
		roles: [],
		employeeBenefits: [],
		passportTypes: [],
		visaTypes: [],
		nationalities: [],
		kids: [],
		inheritances: [],
		siblings: [],
		educations: [],
		certifications: [],
		languages: [],
		skills: [],
		payrollItems: [],
		certificateList: [],
		benefitFiles: [],
		secondLineManagers: [],
		jobGrades: [],
		jobLavels: [],
		budgetAllocations: [],
		fileList: []
	};

	util = new Util();
	gender = 0;
	fixedEmployeeBenefits = [{
		code: "phone_allowance",
		title: "Phone Allowance",
		amount: 0,
		isTaxable: true,
		offeredBy: "ORGANIZATION",
		fix: true
	},
	{
		code: "housing_allowance",
		amount: 0,
		title: "Housing Allowance",
		isTaxable: true,
		offeredBy: "ORGANIZATION",
		fix: true
	},
	{
		code: "gasoline_allowance",
		amount: 0,
		isTaxable: true,
		title: "Gasoline Allowance",
		offeredBy: "ORGANIZATION",
		fix: true
	}
	];

	componentDidMount() {
		getNSSF()
			.then(response => {
				if (response && response.data) {
					const nssf = response.data.data;
					this.props.form.setFieldsValue({
						providentFund: nssf.providentFundStaff
					});
				}
			});

		getMany({ limit: 0 }).then((response) => {
			if (response && response.data) {
				this.setState({
					projects: response.data.map(value => ({
						id: value.id,
						name: value.title,
						code: value.code,
						payload: value.payload ? value.payload : []
					}))
				});
			}

		})

		getFormPayload()
			.then((response) => {
				if (response && response.data) {
					const data = response.data;
					this.setState({
						roles: data.roles,
						departments: data.departments,
						dutyStations: data.dutyStations,
						fifthLineManagers: data.fifthLineManagers,
						fourthLineManagers: data.fourthLineManagers,
						thirdLineManagers: data.thirdLineManagers,
						secondLineManagers: data.secondLineManagers,
						supervisors: data.supervisors,
						teams: data.teams,
						passportTypes: data.passportTypes,
						visaTypes: data.visaTypes,
						nationalities: data.nationalities,
						jobGrades: data.jobGrades,
						jobLavels: data.jobLavels,
					});
				}
			});

		getAllowances()
			.then((response) => {
				if (response.data) {
					this.setState({
						payrollItems: response.data.map((value) => ({
							payrollItemId: value.id,
							code: value.code,
							name: value.title,
							type: value.type,
							taxRate: value.taxRate,
						})),
					});
				}
			});
	}

	onChangeKidAndSiblingName = (value, index, name) => {
		if (name === "kid") {
			const kids = this.state.kids;
			kids[index]["name"] = value;
		} else {
			const siblings = this.state.siblings;
			siblings[index]["name"] = value;
		}

	}

	onChangeKidAndSiblingDate = (value, index, name) => {

		const dob = moment(value).format("YYYY-MM-DD");
		const age = moment().diff(dob, 'years');

		if (name === "kid") {
			const kids = this.state.kids;
			kids[index]["dob"] = dob;
			kids[index]["age"] = age;
			this.setState({
				kids: [...kids]
			})
		} else {
			const siblings = this.state.siblings;
			siblings[index]["dob"] = dob;
			siblings[index]["age"] = age;
			this.setState({
				siblings: [...siblings]
			})
		}
	}

	onChangeCurrentStatus = (value, index, name) => {
		if (name === "kid") {
			const kids = this.state.kids;
			kids[index]["currentStatus"] = value;
			this.setState({
				kids: [...kids]
			})
		} else {
			const siblings = this.state.siblings;
			siblings[index]["currentStatus"] = value;
		}

	}

	onChangeInheritanceName = (value, index, name) => {
		const inheritances = this.state.inheritances;
		inheritances[index][name] = value;
	}

	onChangeBudgetAllocation = (value, index, name) => {
		const budgetAllocations = this.state.budgetAllocations;
		if (name === "project") {
			const foundCode = this.state.projects.find((project) => project.name === value);
			if(foundCode){
				budgetAllocations[index]["project"] = value;
				budgetAllocations[index]["subProject"] = foundCode.code;
				budgetAllocations[index]["payload"] = foundCode.payload;
				budgetAllocations[index]["subProjectCode"] = null;
			}else{
				budgetAllocations[index]["project"] = null;
				budgetAllocations[index]["subProject"] = null;
				budgetAllocations[index]["payload"] = null;
				budgetAllocations[index]["subProjectCode"] = null;
			}
		
			this.setState({
				budgetAllocations: [...budgetAllocations],
			});
		} else {
			budgetAllocations[index][name] = value;
		}
	}

	onChangeSubProjectCode = (subProjectCode, subProjectCodes, index) => {
		const subProject = subProjectCodes.find(value => value.subProject === subProjectCode);
		const budgetAllocations = this.state.budgetAllocations;
		if (subProject) {
				budgetAllocations[index]["subProjectCode"] = subProject.subProject;
				if (subProject.activityCode1) budgetAllocations[index]["activityCode1"] = subProject.activityCode1;
				if (subProject.activityCode2) budgetAllocations[index]["activityCode2"] = subProject.activityCode2;
				if (subProject.activityCode3) budgetAllocations[index]["activityCode3"] = subProject.activityCode3;
				if (subProject.activityCode4) budgetAllocations[index]["activityCode4"] = subProject.activityCode4;
		}
		this.setState({
				budgetAllocations
		})
}

	onChangeSkills = (value, index, name) => {
		const skills = this.state.skills;
		skills[index][name] = value;
	}

	onChangeLanguages = (value, index, name) => {
		const languages = this.state.languages;
		languages[index][name] = value;
	}

	onChangeCertification = (value, index, name) => {
		const certifications = this.state.certifications;
		certifications[index][name] = value;
	}

	onUploadFile = (options, stateName, endPoint) => {

		const { onSuccess, onError, file } = options;
		const formData = new FormData();
		const state = this.state[stateName];
		const config = {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
			},
		};
		const duplicateFile = state.find((value) => value.name === file.name);
		if (duplicateFile) {
			Util.getInstance().sweetAlertMessage("This file already exists!", "warning");
		}
		else {
			formData.append("file", file, file.name);
			axios
				.post(`${getURl()}/file/v1/${endPoint}?clientId=${Util.getInstance().getClientId()}`, formData, config)
				.then((response) => {
					onSuccess("Ok");
					const data = {
						uid: -Math.abs(Math.floor((Math.random() * 100000000000000) + 1)),
						name: response.data.originalname,
						destination: response.data.destination,
						status: 'done',
						url: `${getHostURl()}/${response.data.path}`,
					};
					this.setState({
						[stateName]: [...state, data]
					})
				}
				).catch((err) => {
					onError({ err });
					Util.getInstance().sweetAlertMessage(err.message, "error");
				});
		}
	};

	onRemoveFile = (file, stateName, endPoint) => {
		const id = file.destination.split("/").pop();
		axios({
			method: "DELETE",
			url: `${getURl()}/file/v1/${endPoint}/${id}/${file.name}`,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
			},
		}).then(() => {
			const state = this.state[stateName];
			const stateIndex = state.findIndex((value) => value.name === file.name);
			if (stateIndex >= 0) {
				state.splice(stateIndex, 1);
				this.setState({
					[stateName]: [...state],
				})
			}
		});

	}

	uploadProfilePhoto = (options) => {
		const { file } = options;
		const formData = new FormData();
		const config = {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
			},
		};
		formData.append("photo", file, file.name);
		try {
			axios
				.post(`${getURl()}/file/v1/user/profile`, formData, config)
				.then((response) => {
					if (response.status === 200) {
						this.setState({
							fileList: [{
								uid: '-1',
								name: response.data.filename,
								status: 'done',
								url: `${getHostURl()}/${response.data.path}`,
							}]
						})
					}
				})
		} catch (err) {
			Util.getInstance().sweetAlertMessage(err.message, "error");
		}
	}

	beforeUpload = (file) => {
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isLt2M) {
			Util.getInstance().sweetAlertMessage("Image must smaller than 2MB!", "warning");
		}
		return isLt2M;
	};

	onRemoveProfilePhoto = (file) => {

		axios({
			method: "DELETE",
			url: `${getURl()}/file/v1/user/profile?fileName=${file.name}`,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
			},
		}).then(() => {
			const getClassName = document.getElementsByClassName("ant-upload-list-picture-card-container")[0];
			getClassName.style.display = "none";
			this.setState({
				fileList: []
			})
		})
	}

	uploadKidAttachment = (options, index) => {
		const { file } = options;
		const formData = new FormData();
		const config = {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
			},
		};
		formData.append("attachment", file, file.name);
		try {
			axios
				.post(`${getURl()}/file/v1/kid_attachment`, formData, config)
				.then((response) => {
					if (response.status === 200) {
						const kids = this.state.kids;
						kids[index]["attachment"] = [{
							uid: '-1',
							name: response.data.filename,
							status: 'done',
							url: `${getHostURl()}/${response.data.path}`,
						}];
						this.setState({
							kids: [...kids]
						})
					}
				})
		} catch (err) {
			Util.getInstance().sweetAlertMessage(err.message, "error");
		}
	}

	onRemoveKidAttachment = (file, index) => {
		axios({
			method: "DELETE",
			url: `${getURl()}/file/v1/delete_kid?fileName=${file.name}`,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
			},
		}).then(() => {
			const kids = this.state.kids;
			kids[index]["attachment"] = [];
			this.setState({
				kids: [...kids]
			})
		})
	}

	onChangeEducation = (value, index, name) => {
		const educations = this.state.educations;
		educations[index][name] = value;
	}

	onChangeBenifit = (value, index, name, record) => {
		const employeeBenefits = this.state.employeeBenefits;
		if (record && record.type === 2) {
			employeeBenefits[index][name] = -Math.abs(value)
		} else {
			if (value && value.value) {
				const found = this.state.payrollItems.find((payrollItem) => payrollItem.payrollItemId === value.value);
				employeeBenefits[index]["code"] = found.code;
				employeeBenefits[index]["type"] = found.type;
				employeeBenefits[index]["taxRate"] = found.taxRate;
				employeeBenefits[index]["payrollItemId"] = found.payrollItemId;
			} else {
				employeeBenefits[index][name] = value;
			}
		}
	}

	onChangeBenifitFix = (value, index, name) => {
		this.fixedEmployeeBenefits[index][name] = value;
	}

	onNewButton = (stateName, properties) => {
		const state = this.state[stateName];
		let data = {};
		properties.forEach(property => {
			if (property === "offeredBy") {
				data["offeredBy"] = "ORGANIZATION";
			}
			else if (property === "attachment") {
				data["attachment"] = [];
			}
			else {
				data[property] = undefined;
			}
		});

		this.setState({
			[stateName]: [...state, data]
		});
	};

	onRemoveButtton = (index, stateName) => {
		const state = this.state[stateName];
		state.splice(index, 1);
		this.setState({
			[stateName]: [...state]
		});
	}

	handleCancel = () => {
		this.goBack();
	}

	goBack() {
		this.props.navigate("/employees");
	}

	onFinish = (values) => {
		this.props.form.validateFields().then(() => {
			let insurances = "";
			if (values["insurance"]) {
				values["insurance"].forEach((value, index) => {
					if (index === values["insurance"].length - 1) {
						insurances += `${value}`
					} else {
						insurances += `${value},`
					}
				});
			}
			values["insurance"] = insurances;
			this.state.employeeBenefits.forEach((value, index) => {
				delete values[`amount[${index}]`]
			});
			this.state.kids.forEach((value, index) => {
				delete values[`attachment${index}`]
			});

			this.setState({ loadingButton: true });

			this.state.fileList.length > 0 ? values["photo"] = this.state.fileList[0].name : values["photo"] = ""
			if (values["noticePeriodType"] === "2WEEK") {
				values["noticePayload"] = { "workingDay": 10 };
			} else if (values["noticePeriodType"] === "1MONTH") {
				values["noticePayload"] = { "workingDay": 22 };
			} else if (values["noticePeriodType"] === "2MONTH") {
				values["noticePayload"] = { "workingDay": 44 };
			} else if (values["noticePeriodType"] === "3MONTH") {
				values["noticePayload"] = { "workingDay": 66 };
			} else {
				values["noticePayload"] = { "workingDay": values["noticePayload"] };
			}
			values["noticePayload"] = JSON.stringify(values["noticePayload"]);

			if (values["payrollCurrency"] === undefined) delete values["payrollCurrency"];

			if (values["contractType"] === Enum.CONTRACT_TYPE.UDC) {
				values["contractEndDate"] = null;
			} else {
				values["contractEndDate"] = this.util.formatDateForMYSQL(values["contractEndDate"]);
			}
			if (values["status"] === 0) {
				values["lastWorkingDay"] = values["lastWorkingDay"] ? this.util.formatDateForMYSQL(values["lastWorkingDay"]) : null;
			} else {
				values["lastWorkingDay"] = null;
			}

			if (values["seniority_severancePay"]) {
				if (values["seniority_severancePay"] === "SENIORITY") {
					values["seniority"] = 1;
					values["severancePay"] = 0;
				} else {
					values["seniority"] = 0;
					values["severancePay"] = 1;
				}
			} else {
				values["seniority"] = 0;
				values["severancePay"] = 0;
			}

			if (values["seniority_severancePay"] === undefined) {
				values["seniority"] = null;
				values["severancePay"] = null;
			}

			delete values["seniority_severancePay"];


			if (values["joinDate"]) values["joinDate"] = this.util.formatDateForMYSQL(values.joinDate);
			if (values["probationExpiredDate"]) values["probationExpiredDate"] = this.util.formatDateForMYSQL(values.probationDate);
			if (values["dob"]) values["dob"] = this.util.formatDateForMYSQL(values.dob);
			if (values["expiredDate"]) values["expiredDate"] = this.util.formatDateForMYSQL(values.expiredDate);
			if (values["passportExpiredDate"]) values["passportExpiredDate"] = this.util.formatDateForMYSQL(values.passportExpiredDate);
			if (values["passportIssuedDate"]) values["passportIssuedDate"] = this.util.formatDateForMYSQL(values.passportIssuedDate);
			if (values["visaExpiredDate"]) values["visaExpiredDate"] = this.util.formatDateForMYSQL(values.visaExpiredDate);

			values["phoneAllowance"] = this.fixedEmployeeBenefits[0];
			values["housingAllowance"] = this.fixedEmployeeBenefits[1];
			values["gasolineAllowance"] = this.fixedEmployeeBenefits[2];
			values["employeeBenefits"] = this.state.employeeBenefits.filter((values) => values.code);

			values["isNoticeTerminate"] = values["isNoticeTerminate"] === undefined ? null : values["isNoticeTerminate"];

			values["kids"] = this.state.kids.filter((value) => (value.name || value.dob || value.currentStatus))
				.map((value) => ({
					name: value.name,
					dob: value.dob,
					currentStatus: value.currentStatus,
					attachment: value.attachment.length > 0 ? value.attachment[0].name : null
				}));
			values["siblings"] = this.state.siblings.filter((value) => (value.name || value.dob || value.currentStatus));
			values["inheritances"] = this.state.inheritances.filter((value) => (value.name || value.idCard || value.percentage));
			values["educations"] = this.state.educations.filter((value) => (value.institute || value.degree || value.date));
			values["certifications"] = this.state.certifications.filter((value) => (value.title || value.authority || value.date));
			values["skills"] = this.state.skills.filter((value) => (value.title || value.level));
			values["languages"] = this.state.languages.filter((value) => (value.title || value.proficiency));
			values["certificateFiles"] = this.state.certificateList.map((value) => ({ destination: value.destination, originalname: value.name }));
			values["benefitFiles"] = this.state.benefitFiles.map((value) => ({ destination: value.destination, originalname: value.name }));
			values["budgetAllocations"] = this.state.budgetAllocations.filter((value) => (value.project || value.subProject || value.percentage));

			values["supervisorId"] = values["supervisorId"] === undefined ? null : values["supervisorId"];
			values["projectManagerId"] = values["projectManagerId"] === undefined ? null : values["projectManagerId"];
			values["headOfDepartmentId"] = values["headOfDepartmentId"] === undefined ? null : values["headOfDepartmentId"];
			values["fourthLineManagerId"] = values["fourthLineManagerId"] === undefined ? null : values["fourthLineManagerId"];
			values["fifthLineManagerId"] = values["fifthLineManagerId"] === undefined ? null : values["fifthLineManagerId"];
			values["jobGradeId"] = values["jobGradeId"] === undefined ? null : values["jobGradeId"];
			values["step"] = values["step"] === undefined ? null : values["step"];
			values["jobLevelId"] = values["jobLevelId"] === undefined ? null : values["jobLevelId"];
			values["teamId"] = values["teamId"] === undefined ? null : values["teamId"];
			values["teamId"] = values["teamId"] === undefined ? null : values["teamId"];
			values["isNoticeTerminate"] = values["isNoticeTerminate"] === undefined ? null : values["isNoticeTerminate"];
			values["terminationBenefit"] = values["terminationBenefit"] === undefined ? null : values["terminationBenefit"];
			values["annualSalary"] = values["annualSalary"] === undefined ? null : values["annualSalary"];
			values["dutyStation"] = values["dutyStation"] === undefined ? null : values["dutyStation"];
			if(values["spouseWorkingStatus"] === undefined){
				values["spouseWorkingStatus"] = null
			}
			insertNewRecord(values)
				.then((response) => {
					swal({
						title: "Success!",
						text: "Employee information saved successfully!",
						icon: "success",
						timer: 1000
					})
						.then(() => {
							this.props.navigate(`/employees/update/${response?.data?.data?.id}`);
						});
				})
				.catch(err => {
					if (err?.response?.data?.error?.message) {
						swal({
							title: err.response.data.error.message,
							icon: "error",
							dangerMode: true
						});
					}
				})
				.finally(() => {
					this.setState({ loadingButton: false });
				});
		});
	};

	onChange = (e) => {
		this.gender = e.target.value;
	};

	onChangeNoticePeriodType = (value) => {
		const visible = document.getElementById("notice-period-type-working-day");
		if (value === "CUSTOM") {
			visible.style.display = "";
		} else {
			visible.style.display = "none";
		}
	}

	onChangeContractType = (values) => {
		const visible = document.getElementById("contract-end-date");
		if (values === Enum.CONTRACT_TYPE.UDC) {
			visible.style.display = "none";
			this.setState({ requiredContractEndDate: false })
		} else {
			visible.style.display = "";
			this.setState({ requiredContractEndDate: true })
		}
	}

	onChangeNoticeTerminate = (value) => {
		const visible = document.getElementById("notice-period-type");
		if (value === 0) {
			visible.style.display = "";
			this.setState({ requiredNoticePeriodType: true });
		} else {
			visible.style.display = "none";
			this.setState({ requiredNoticePeriodType: false })
			this.props.form.setFieldsValue({
				noticePeriodType: undefined,
			});
		}
	}

	onChangeStatus = (values) => {
		const visible = document.getElementById("last-working-day");
		if (values === 0) {
			visible.style.display = "";
			this.setState({ requiredLastWorkingDay: true })
		} else {
			visible.style.display = "none";
			this.setState({ requiredLastWorkingDay: false })
		}
	}

	onChangeStep = (value) => {
		this.setState({ currentStep: value });
		const access = document.getElementById(`profile-${value}`);
		access.scrollIntoView({ behavior: "smooth" }, true)
	}

	onChangeMaritalStatus = (value) => {
		if (value === "MARRIED") {
			this.props.form.setFieldsValue({
				spouseWorkingStatus: 1
			});
		} else {
			this.props.form.setFieldsValue({
				spouseWorkingStatus: null
			})
		}
	}

	render() {
		const {
			loadingButton,
			requiredContractEndDate,
			requiredNoticePeriodType,
			departments,
			dutyStations,
			roles,
			fifthLineManagers,
			fourthLineManagers,
			thirdLineManagers,
			supervisors,
			teams,
			kids,
			employeeBenefits,
			siblings,
			visaTypes,
			passportTypes,
			nationalities,
			inheritances,
			educations,
			certifications,
			languages,
			skills,
			payrollItems,
			certificateList,
			secondLineManagers,
			jobGrades,
			jobLavels,
			budgetAllocations,
			benefitFiles,
			fileList,
			requiredLastWorkingDay,
			projects,
		} = this.state;
		return (
			<>
				{
					Util.getInstance().hasPermission("create", "employee")
						?
						<Form
							form={this.props.form}
							onFinish={this.onFinish}
							onFieldsChange={() => this.state.errorFields.length ? this.setState({ errorFields: [] }) : {}}
							onFinishFailed={error => this.setState({ errorFields: error.errorFields })}
							layout="vertical"
							className="personal-form"
						>
							<Row className="btn-navigation">
								<Col span={12}>
									<div className="pull-left">
										<Button onClick={this.handleCancel}>
											<ArrowLeftOutlined />
											{t("text_back")}
										</Button>
										<span className="title">
											{t("text_new_employee")}
										</span>
									</div>
								</Col>
								<Col span={12}>
									<div className="pull-right">
										<Button htmlType="submit" loading={loadingButton}>{t("text_save")}</Button>
									</div>
								</Col>
							</Row>
							<Card>
								<Steps
									current={this.state.currentStep}
									onChange={this.onChangeStep}
								>
									<Steps.Step title="Personal Information" />
									<Steps.Step title="Contacts" />
									<Steps.Step title="Education" />
									<Steps.Step title="Job Profile" />
									<Steps.Step title="Compensation & Benefit" />
								</Steps>
							</Card>
							<div className="scroll-employee" style={{ backgroundColor: "#f2f4f4" }}>
								{
									this.state.errorFields.length > 0 &&
									<Card style={{ marginBottom: 25 }}>
										{
											this.state.errorFields.map((errorField, key1) =>
												errorField.errors.map((error, key2) => errorField.errors.map((error, key2) => <Tag style={{ marginTop: 5 }} key={`${key1}-${key2}`} icon={<CloseCircleOutlined />} color="error" onClick={() => { const access = document.getElementById(errorField.name[0]); access.scrollIntoView({ behavior: "smooth" }, true) }}>{error}</Tag>))
											)
										}
									</Card>
								}
								<Card title={t("text_personal_information")} bordered={false} className="employee-form" style={{ marginBottom: 25 }} id="profile-0">
									<Row gutter={25}>
										<Col lg={18}>
											<Row gutter={25}>
												<Col lg={6}>
													<InputText
														label={t("text_employee_id")}
														name="code"
														placeholder={t("text_enter_a_unique_id")}
														requiredMessage={t("text_enter_a_unique_id_i")}
														className="width-input"
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														label={t("text_first_name")}
														name="firstName"
														placeholder={t("text_enter_first_name")}
														requiredMessage={t("text_enter_first_name")}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														label={t("text_last_name")}
														name="lastName"
														placeholder={t("text_enter_last_name")}
														requiredMessage={t("text_enter_last_name")}
													/>
												</Col>
												<Col lg={6}>
													<SelectInput
														name="gender"
														label={t("text_gender")}
														placeholder={t("text_gender")}
														allowClear={false}
														required={true}
														valueKey="id"
														dataSource={[
															{ id: Enum.GENDER.MALE, name: t("text_male") },
															{ id: Enum.GENDER.FEMALE, name: t("text_female") },
															{ id: Enum.GENDER.OTHER, name: t("text_other") }
														]}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														label={t("text_first_name_kh")}
														name="firstNameKH"
														placeholder={t("text_enter_first_name")}
														requiredMessage={t("text_enter_first_name")}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														label={t("text_last_name_kh")}
														name="lastNameKH"
														placeholder={t("text_enter_last_name")}
														requiredMessage={t("text_enter_last_name")}
													/>
												</Col>
												<Col lg={6}>
													<SelectInput
														name="maritalStatus"
														label={t("text_marital_status")}
														placeholder={t("text_select_marital_status")}
														onChange={this.onChangeMaritalStatus}
														required={true}
														valueKey="id"
														dataSource={[
															{ id: "SINGLE", name: t("text_single") },
															{ id: "MARRIED", name: t("text_Married") },
															{ id: "DIVORCED", name: t("text_separated") },
														]}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														label={t("text_current_address")}
														name="address"
														placeholder={t("text_enter_current_address")}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputDate
														name="dob"
														required={true}
														errorMessage={t("text_please_select_date_of_birth")}
														allowClear={false}
														placeholder={t("text_dd_mm_yyyy")}
														style={{ width: "100%" }}
														format="DD/MM/YYYY"
														label={t("text_date_of_birth")}
													/>
												</Col>
												<Col lg={6}>
													<InputText
														label={t("text_place_of_birth")}
														name="placeOfBirth"
														placeholder={t("text_enter_place_of_birth")}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														label={t("text_national_id_number")}
														name="nationIDNumber"
														placeholder={t("text_enter_national_id_number")}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputDate
														name="expiredDate"
														placeholder={t("text_dd_mm_yyyy")}
														style={{ width: "100%" }}
														format="DD/MM/YYYY"
														label={t("text_expired_date")}
													/>
												</Col>
												<Col lg={6}>
													<SelectInput
														name="nationalityId"
														label={t("text_nationality")}
														placeholder={t("text_select_nationality")}
														valueKey="id"
														dataSource={nationalities}
														allowClear={true}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														label={t("text_ethnicity")}
														name="ethnicity"
														placeholder={t("text_enter_ethnicity")}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														label={t("text_religious")}
														name="religious"
														placeholder={t("text_enter_religious")}
													/>
												</Col>
												<Col lg={6}>
													<InputText
														name="bankAccNumber"
														placeholder={t("text_bank_acc_no")}
														label={t("text_bank_acc_no")}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														name="notifyEmail"
														placeholder={t("text_enter_notify_email")}
														label={t("text_notify_email")}
														requiredMessage={t("text_enter_notify_email")}
													/>
												</Col>
												<Col lg={6} offset={2}>
													<InputText
														name="userName"
														placeholder={t("text_enter_account")}
														label={t("text_username")}
														requiredMessage={t("text_enter_account")}
													/>
												</Col>
											</Row>
										</Col>
										<Col lg={6} >
											<div className={"upload-profile-photo"}>
												<Upload
													customRequest={this.uploadProfilePhoto}
													listType="picture-card"
													fileList={fileList}
													onRemove={this.onRemoveProfilePhoto}
													beforeUpload={this.beforeUpload}
												>

													{fileList.length < 1 && '+ Upload Profile'}

												</Upload>
											</div>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_passport_information")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={6} >
											<SelectInput
												name="passportTypeId"
												label={t("text_passport_type")}
												placeholder={t("text_select_passport_type")}
												valueKey="id"
												dataSource={passportTypes}
												allowClear={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_passport_number")}
												name="passportNumber"
												placeholder={t("text_enter_passport_number")}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputDate
												name="passportIssuedDate"
												placeholder={t("text_dd_mm_yyyy")}
												style={{ width: "100%" }}
												format="DD/MM/YYYY"
												label={t("text_date_of_issued")}
											/>
										</Col>
										<Col lg={6} >
											<InputText
												label={t("text_place_of_issued")}
												name="passportIssuedPlace"
												placeholder={t("text_enter_place_of_issued")}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputDate
												name="passportExpiredDate"
												placeholder={t("text_dd_mm_yyyy")}
												style={{ width: "100%" }}
												format="DD/MM/YYYY"
												label={t("text_expired_date")}
												disabledDate={current => current <= moment(this.props.form.getFieldValue("joinDate"))}
											/>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_visa_information")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={6} >
											<SelectInput
												name="visaTypeId"
												label={t("text_visa_type")}
												placeholder={t("text_select_visa_type")}
												valueKey="id"
												dataSource={visaTypes}
												allowClear={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_visa_number")}
												name="visaNumber"
												placeholder={t("text_enter_visa_number")}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputDate
												name="visaExpiredDate"
												placeholder={t("text_dd_mm_yyyy")}
												style={{ width: "100%" }}
												format="DD/MM/YYYY"
												label={t("text_expired_date")}
											/>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_spouse_and_kids_information")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={6}>
											<InputText
												label={t("text_spouse_name")}
												name="spouseName"
												placeholder={t("text_enter_spouse_name")}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="spouseWorkingStatus"
												label={t("text_working")}
												placeholder={t("text_select_working")}
												allowClear={true}
												valueKey="id"
												dataSource={[
													{ id: 0, name: t("text_No") },
													{ id: 1, name: t("text_yes") },
												]}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_occupation")}
												name="spouseOccupation"
												placeholder={t("text_enter_spouse_occupation")}
											/>
										</Col>
										<Col lg={24}>
											<div style={{ marginBottom: 25 }}>
												<Table
													rowKey={() => `kids${Date.now() + Math.random()}`}
													style={{ marginTop: 15 }}
													dataSource={kids}
													columns={[
														{
															title: t("text_kid_name"),
															dataIndex: "name",
															key: "name",
															render: (name, record, index) => {
																return (
																	<InputText
																		defaultValue={name}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_kid_name")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeKidAndSiblingName(event.target.value, index, "kid")}
																	/>
																);
															}
														},
														{
															title: t("text_date_of_birth"),
															dataIndex: "dob",
															key: "dob",
															width: 251,
															render: (dob, record, index) => {
																return (
																	<InputDate
																		defaultValue={dob && moment(dob)}
																		placeholder={t("text_dd_mm_yyyy")}
																		format="DD/MM/YYYY"
																		style={{ marginBottom: 0 }}
																		onChange={(value) => this.onChangeKidAndSiblingDate(value, index, "kid")}
																		isAutoSelect={true}
																	/>
																);
															}
														},
														{
															title: t("text_age"),
															dataIndex: "age",
															key: "age",
															render: (age) => <div style={{ alignItems: "center", display: "flex" }}> {age} </div>
														},
														{
															title: t("text_current_status"),
															dataIndex: "currentStatus",
															key: "currentStatus",
															render: (currentStatus, record, index) => {
																return (
																	<SelectInput
																		placeholder={t("text_select_current_status")}
																		valueKey="id"
																		style={{ marginBottom: 0 }}
																		allowClear={true}
																		onChange={(value) => this.onChangeCurrentStatus(value, index, "kid")}
																		defaultValue={currentStatus}
																		isAutoSelect={true}
																		dataSource={[
																			{ id: "UNDER_CONTROLL", name: t("text_under_controll") },
																			{ id: "OUT_OF_CONTROLL", name: t("text_out_of_controll") },
																		]}
																	/>
																);
															}
														},
														{
															title: "Attachment",
															dataIndex: "attachment",
															key: "attachment",
															render: (attachment, record, index) => {
																this.props.form.setFieldsValue({
																	[`attachment${index}`]: attachment.length > 0 ? attachment : undefined
																})
																return (
																	<Form.Item
																		name={`attachment${index}`}
																		rules={[
																			{
																				required: (record.age > 18 && record.currentStatus === "UNDER_CONTROLL") ? true : false,
																				message: "Please upload file!",
																			},
																		]}
																		style={{ marginBottom: 0 }}
																	>
																		<div className={"upload-kid-attachment"}>
																			<Upload
																				customRequest={(options) => this.uploadKidAttachment(options, index)}
																				fileList={attachment}
																				onRemove={(file) => this.onRemoveKidAttachment(file, index)}
																			>

																				{attachment.length < 1 && <Button icon={<PaperClipOutlined />} style={{ border: "1px dotted #8F989F" }}>attachment</Button>}

																			</Upload>
																		</div>
																	</Form.Item>
																)
															}
														},
														{
															title: t("text_action"),
															dataIndex: "id",
															key: "id",
															width: 160,
															align: "center",
															render: (id, record, index) => {
																return (
																	<div style={{
																		fontSize: 23,
																		color: "red"
																	}}>
																		<CloseOutlined onClick={() => this.onRemoveButtton(index, "kids")} />
																	</div>
																);
															},
														},
													]}
													pagination={false}
													footer={() =>
														<Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => this.onNewButton("kids", ["name", "currentStatus", "dob", "attachment"])}>
															{t("text_add_new")}
														</Button>
													}
												/>
											</div>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_sibling_parents_and_other_information")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={6}>
											<InputText
												label={t("text_mother_name")}
												name="motherName"
												placeholder={t("text_enter_mother_name")}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_father_name")}
												name="fatherName"
												placeholder={t("text_enter_father_name")}
											/>
										</Col>
										<Col lg={24}>
											<div style={{ marginBottom: 25 }}>
												<Table
													rowKey={() => `sibling${Date.now() + Math.random()}`}
													style={{ marginTop: 15 }}
													dataSource={siblings}
													columns={[
														{
															title: "Name of Sibling",
															dataIndex: "name",
															key: "name",
															render: (name, record, index) => {
																return (
																	<InputText
																		defaultValue={name}
																		style={{ marginBottom: 0 }}
																		placeholder="Enter name of sibling"
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeKidAndSiblingName(event.target.value, index, "sibling")}
																	/>
																);
															}
														},
														{
															title: t("text_date_of_birth"),
															dataIndex: "dob",
															key: "dob",
															width: 251,
															render: (dob, record, index) => {
																return (
																	<InputDate
																		defaultValue={dob && moment(dob)}
																		placeholder={t("text_dd_mm_yyyy")}
																		style={{ marginBottom: 0 }}
																		format="DD/MM/YYYY"
																		onChange={(value) => this.onChangeKidAndSiblingDate(value, index, "sibling")}
																		isAutoSelect={true}
																	/>
																);
															}
														},
														{
															title: t("text_age"),
															dataIndex: "age",
															key: "age",
															render: (age) => <div style={{ alignItems: "center", display: "flex" }}> {age} </div>
														},
														{
															title: t("text_current_status"),
															dataIndex: "currentStatus",
															key: "currentStatus",
															render: (currentStatus, record, index) => {
																return (
																	<SelectInput
																		placeholder={t("text_select_current_status")}
																		style={{ marginBottom: 0 }}
																		valueKey="id"
																		onChange={(value) => this.onChangeCurrentStatus(value, index, "sibling")}
																		defaultValue={currentStatus}
																		isAutoSelect={true}
																		allowClear={true}
																		dataSource={[
																			{ id: "UNDER_CONTROLL", name: t("text_under_controll") },
																			{ id: "OUT_OF_CONTROLL", name: t("text_out_of_controll") },
																		]}
																	/>
																);
															}
														},
														{
															title: t("text_action"),
															dataIndex: "id",
															key: "id",
															width: 160,
															align: "center",
															render: (id, record, index) => {
																return (
																	<div style={{
																		fontSize: 23,
																		color: "red"
																	}}>
																		<CloseOutlined onClick={() => this.onRemoveButtton(index, "siblings")} />
																	</div>
																);
															},
														},
													]}
													pagination={false}
													footer={() =>
														<Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => this.onNewButton("siblings", ["name", "currentStatus", "dob"])}>
															{t("text_add_new")}
														</Button>
													}
												/>
											</div>
										</Col>
										<Col lg={6}>
											<InputText
												label={t("text_nssf_number")}
												name="nssfNumber"
												placeholder={t("text_enter_nssf_number")}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_workbook_number")}
												name="workbookNumber"
												placeholder={t("text_enter_workbook_number")}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_workpermit_number")}
												name="workPermitNumber"
												placeholder={t("text_enter_workpermit_number")}
											/>
										</Col>
										<Col lg={6}>
											<InputText
												label={t("text_tax_identification_number")}
												name="taxIdentificationNumber"
												placeholder={t("text_enter_tax_identification_number")}
											/>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_next_of_king_information")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={24}>
											<div style={{ marginBottom: 25 }}>
												<Table
													rowKey={() => `inheritance${Date.now() + Math.random()}`}
													style={{ marginTop: 15 }}
													dataSource={inheritances}
													columns={[
														{
															title: t("text_name"),
															dataIndex: "name",
															key: "name",
															render: (name, record, index) => {
																return (
																	<InputText
																		defaultValue={name}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_enter_name")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeInheritanceName(event.target.value, index, "name")}
																	/>
																);
															}
														},
														{
															title: t("text_national_id_number"),
															dataIndex: "idCard",
															key: "idCard",
															render: (idCard, record, index) => {
																return (
																	<InputText
																		defaultValue={idCard}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_enter_national_id_number")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeInheritanceName(event.target.value, index, "idCard")}
																	/>
																);
															}
														},
														{
															title: t("text_inheritance"),
															dataIndex: "percentage",
															key: "percentage",
															render: (percentage, record, index) => {
																return (
																	<NumberInput
																		defaultValue={percentage}
																		placeholder={t("text_enter_inheritances")}
																		style={{ marginBottom: 0 }}
																		max={100}
																		onChange={(value) => this.onChangeInheritanceName(value, index, "percentage")}
																		isAutoSelect={true}
																	/>
																);
															}
														},
														{
															title: t("text_action"),
															dataIndex: "id",
															key: "id",
															width: 160,
															align: "center",
															render: (id, record, index) => {
																return (
																	<div style={{
																		fontSize: 23,
																		color: "red"
																	}}>
																		<CloseOutlined onClick={() => this.onRemoveButtton(index, "inheritances")} />
																	</div>
																);
															},
														},
													]}
													pagination={false}
													footer={() =>
														<Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => this.onNewButton("inheritances", ["name", "idCard", "percentage"])}>
															{t("text_add_new")}
														</Button>
													}
												/>
											</div>
										</Col>
									</Row>
								</Card>
								<Card title={t("text_contacts_information")} bordered={false} className="employee-form" style={{ marginBottom: 25 }} id="profile-1">
									<Row gutter={25}>
										<Col lg={6}>
											<InputText
												label={t("text_contact_number_1")}
												name="contactNumber"
												placeholder={t("text_enter_contact_number_1")}
												isAutoSelect={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_contact_number_2")}
												name="contactNumber2"
												placeholder={t("text_enter_contact_number_2")}
												isAutoSelect={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_contact_number_3")}
												name="contactNumber3"
												placeholder={t("text_enter_contact_number_3")}
												isAutoSelect={true}
											/>
										</Col>
										<Col lg={6}>
											<Form.Item
												name="email"
												label={t("text_personal_email")}
												rules={[
													{
														required: true
													},
													{
														type: "email",
														message: "Email is not valid"
													}
												]}
											>
												<Input placeholder={t("text_enter_personal_email")} />
											</Form.Item>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_emergency_contact_name")}
												name="emergencyContactName"
												placeholder={t("text_enter_emergency_contact_name")}
												isAutoSelect={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_emergency_contact_number")}
												name="emergencyContactNumber"
												placeholder={t("text_enter_emergency_contact_number")}
												isAutoSelect={true}
											/>
										</Col>
									</Row>
								</Card>
								<Card title={t("text_education_information")} bordered={false} className="employee-form" style={{ marginBottom: 25 }} id="profile-2">
									<Row gutter={25}>
										<Col lg={24}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_national_education")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={24}>
											<div style={{ marginBottom: 25 }}>
												<Table
													rowKey={() => `educations${Date.now() + Math.random()}`}
													style={{ marginTop: 15 }}
													dataSource={educations}
													columns={[
														{
															title: t("text_institute"),
															dataIndex: "institute",
															key: "institute",
															render: (institute, record, index) => {
																return (
																	<InputText
																		defaultValue={institute}
																		placeholder={t("text_enter_institute")}
																		style={{ marginBottom: 0 }}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeEducation(event.target.value, index, "institute")}
																	/>
																);
															}
														},
														{
															title: t("text_degree"),
															dataIndex: "degree",
															key: "degree",
															render: (degree, record, index) => {
																return (
																	<InputText
																		defaultValue={degree}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_eg_bachelor_of_arts_in_english")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeEducation(event.target.value, index, "degree")}
																	/>
																);
															}
														},
														{
															title: t("text_date_s"),
															dataIndex: "date",
															key: "date",
															render: (date, record, index) => {
																return (
																	<InputText
																		defaultValue={date}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_date_s_placeholder")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeEducation(event.target.value, index, "date")}
																	/>
																);
															}
														},
														{
															title: t("text_action"),
															dataIndex: "id",
															key: "id",
															width: 160,
															align: "center",
															render: (id, record, index) => {
																return (
																	<div style={{
																		fontSize: 23,
																		color: "red"
																	}}>
																		<CloseOutlined onClick={() => this.onRemoveButtton(index, "educations")} />
																	</div>
																);
															},
														},
													]}
													pagination={false}
													footer={() =>
														<Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => this.onNewButton("educations", ["institute", "degree", "date"])}>
															{t("text_add_new")}
														</Button>
													}
												/>
											</div>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_short_course_certification")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={24}>
											<div style={{ marginBottom: 25 }}>
												<Table
													rowKey={() => `certifications${Date.now() + Math.random()}`}
													style={{ marginTop: 15 }}
													dataSource={certifications}
													columns={[
														{
															title: t("text_title"),
															dataIndex: "title",
															key: "title",
															render: (title, record, index) => {
																return (
																	<InputText
																		defaultValue={title}
																		placeholder={t("text_name_of_certification")}
																		style={{ marginBottom: 0 }}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeCertification(event.target.value, index, "title")}
																	/>
																);
															}
														},
														{
															title: t("text_certifying_authority"),
															dataIndex: "authority",
															key: "authority",
															render: (authority, record, index) => {
																return (
																	<InputText
																		defaultValue={authority}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_certifying_authority_placeholder")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeCertification(event.target.value, index, "authority")}
																	/>
																);
															}
														},
														{
															title: t("text_date_s"),
															dataIndex: "date",
															key: "date",
															render: (date, record, index) => {
																return (
																	<InputText
																		defaultValue={date}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_date_s_placeholder")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeCertification(event.target.value, index, "date")}
																	/>
																);
															}
														},
														{
															title: t("text_action"),
															dataIndex: "id",
															key: "id",
															width: 160,
															align: "center",
															render: (id, record, index) => {
																return (
																	<div style={{
																		fontSize: 23,
																		color: "red"
																	}}>
																		<CloseOutlined onClick={() => this.onRemoveButtton(index, "certifications")} />
																	</div>
																);
															},
														},
													]}
													pagination={false}
													footer={() =>
														<Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => this.onNewButton("certifications", ["title", "authority", "date"])}>
															{t("text_add_new")}
														</Button>
													}
												/>
											</div>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", marginBottom: 15 }}>{t("text_attachment_of_education_certificate")}</p>
										</Col>

										<Col lg={24}>
											<div id="employee-upload-file">
												<Dragger
													customRequest={(options) => this.onUploadFile(options, "certificateList", "upload_certificate")}
													multiple={true}
													onRemove={(file) => this.onRemoveFile(file, "certificateList", "delete_certificate?path=certificates")}
													fileList={certificateList}
												>
													<p className="ant-upload-drag-icon">
														<PaperClipOutlined style={{ fontSize: 35 }} />
													</p>
													<p className="ant-upload-text" style={{ fontSize: 16, fontWeight: 400, color: "#000000", letterpacing: "-0.38px" }}>Click or drag file to this area to upload</p>
													<p className="ant-upload-hint">
														Support for a single or bulk upload. Strictly prohibit from uploading education or other
														course files
													</p>
												</Dragger>
											</div>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_languages")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={24}>
											<div style={{ marginBottom: 25 }}>
												<Table
													rowKey={() => `languages${Date.now() + Math.random()}`}
													style={{ marginTop: 15 }}
													dataSource={languages}
													columns={[
														{
															title: t("text_language"),
															dataIndex: "title",
															key: "title",
															render: (title, record, index) => {
																return (
																	<InputText
																		defaultValue={title}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_eg_khmer")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeLanguages(event.target.value, index, "title")}
																	/>
																);
															}
														},
														{
															title: t("text_proficiency"),
															dataIndex: "proficiency",
															key: "proficiency",
															render: (proficiency, record, index) => {
																return (
																	<InputText
																		style={{ marginBottom: 0 }}
																		defaultValue={proficiency}
																		placeholder={t("text_proficiency_placeholder")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeLanguages(event.target.value, index, "proficiency")}
																	/>
																);
															}
														},
														{
															title: t("text_action"),
															dataIndex: "id",
															key: "id",
															width: 160,
															align: "center",
															render: (id, record, index) => {
																return (
																	<div style={{
																		fontSize: 23,
																		color: "red"
																	}}>
																		<CloseOutlined onClick={() => this.onRemoveButtton(index, "languages")} />
																	</div>
																);
															},
														},
													]}
													pagination={false}
													footer={() =>
														<Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => this.onNewButton("languages", ["title", "proficiency"])}>
															{t("text_add_new")}
														</Button>
													}
												/>
											</div>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_skills")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={24}>
											<div style={{ marginBottom: 25 }}>
												<Table
													rowKey={() => `skills${Date.now() + Math.random()}`}
													style={{ marginTop: 15 }}
													dataSource={skills}
													columns={[
														{
															title: t("text_title"),
															dataIndex: "title",
															key: "title",
															render: (title, record, index) => {
																return (
																	<InputText
																		defaultValue={title}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_eg_computer_skill")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeSkills(event.target.value, index, "title")}
																	/>
																);
															}
														},
														{
															title: t("text_level"),
															dataIndex: "level",
															key: "level",
															render: (level, record, index) => {
																return (
																	<InputText
																		defaultValue={level}
																		style={{ marginBottom: 0 }}
																		placeholder={t("text_level_placeholder")}
																		isAutoSelect={true}
																		onChange={(event) => this.onChangeSkills(event.target.value, index, "level")}
																	/>
																);
															}
														},
														{
															title: t("text_action"),
															dataIndex: "id",
															key: "id",
															width: 160,
															align: "center",
															render: (id, record, index) => {
																return (
																	<div style={{
																		fontSize: 23,
																		color: "red"
																	}}>
																		<CloseOutlined onClick={() => this.onRemoveButtton(index, "skills")} />
																	</div>
																);
															},
														},
													]}
													pagination={false}
													footer={() =>
														<Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => this.onNewButton("skills", ["title", "level"])}>
															{t("text_add_new")}
														</Button>
													}
												/>
											</div>
										</Col>
									</Row>
								</Card>
								<Card title={t("text_approval_setting")} className="employee-form" bordered={false} style={{ marginBottom: 25 }} id="approval-setting-3">
									<Row gutter={25}>
										<Col lg={6}>
											<Form.Item
												name="approver1Id"
												label={t("text_approval_leave_ot")}
												rules={[
													{
														required: true,
														message: "Who approves leave and overtime requests?",
													},
												]}
											>
												<Select
													style={{
														width: "100%",
													}}
													fieldNames={{ label: "name", value: "id" }}
													placeholder="Who approves leave and overtime requests?"
													options={[
														{
															name: "5th Line Managers",
															options: fifthLineManagers
														},
														{
															name: "4th Line Managers",
															options: fourthLineManagers
														},
														{
															name: "3rd Line Managers",
															options: thirdLineManagers
														},
														{
															name: "2nd Line Managers",
															options: secondLineManagers
														},
														{
															name: "1st Line Managers",
															options: supervisors
														}
													]}
												/>
											</Form.Item>
										</Col>
										<Col lg={6} offset={2}>
											<Form.Item
												name="approver2Id"
												label={t("text_approval_pdd")}
												rules={[
													{
														required: true,
														message: "Who approves PDD?"
													},
												]}
											>
												<Select
													style={{
														width: "100%",
													}}
													fieldNames={{ label: "name", value: "id" }}
													placeholder="Who approves PDD?"
													options={[
														{
															name: "5th Line Managers",
															options: fifthLineManagers
														},
														{
															name: "4th Line Managers",
															options: fourthLineManagers
														},
														{
															name: "3rd Line Managers",
															options: thirdLineManagers
														},
														{
															name: "2nd Line Managers",
															options: secondLineManagers
														},
														{
															name: "1st Line Managers",
															options: supervisors
														}
													]}
												/>
											</Form.Item>
										</Col>
										<Col lg={6} offset={2}>
											<Form.Item
												name="actingById"
												label={t("text_acting_by")}
											>
												<Select
													style={{
														width: "100%",
													}}
													fieldNames={{ label: "name", value: "id" }}
													placeholder="Select employees who are currently acting."
													options={[
														{
															name: "5th Line Managers",
															options: fifthLineManagers
														},
														{
															name: "4th Line Managers",
															options: fourthLineManagers
														},
														{
															name: "3rd Line Managers",
															options: thirdLineManagers
														},
														{
															name: "2nd Line Managers",
															options: secondLineManagers
														},
														{
															name: "1st Line Managers",
															options: supervisors
														}
													]}
												/>
											</Form.Item>
										</Col>
										<Col lg={6}>
											<InputDate
												name="actingStart"
												placeholder={t("text_dd_mm_yyyy")}
												style={{ width: "100%" }}
												format="DD/MM/YYYY"
												label={t("text_acting_start")}
												allowClear={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputDate
												name="actingEnd"
												placeholder={t("text_dd_mm_yyyy")}
												style={{ width: "100%" }}
												format="DD/MM/YYYY"
												label={t("text_acting_end")}
												allowClear={true}
											/>
										</Col>
									</Row>
								</Card>
								<Card title={t("text_job_profile")} className="employee-form" bordered={false} style={{ marginBottom: 25 }} id="profile-3">
									<Row gutter={25}>
										<Col lg={6} >
											<SelectInput
												name="supervisorId"
												placeholder={t("text_select_1st_line_manager")}
												label={t("text_1st_line_manager")}
												allowClear={true}
												valueKey="id"
												errorMessage={t("text_please_select_1st_line_manager")}
												dataSource={supervisors}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="projectManagerId"
												placeholder={t("text_select_2nd_line_manager")}
												label={t("text_2nd_line_manager")}
												valueKey="id"
												dataSource={secondLineManagers}
												allowClear={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="headOfDepartmentId"
												placeholder={t("text_select_3rd_line_manager")}
												label={t("text_3rd_line_manager")}
												valueKey="id"
												dataSource={thirdLineManagers}
												allowClear={true}
											/>
										</Col>
										<Col lg={6}>
											<SelectInput
												name="fourthLineManagerId"
												placeholder={t("text_select_4th_line_manager")}
												label={t("text_4th_line_manager")}
												valueKey="id"
												dataSource={fourthLineManagers}
												allowClear={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="fifthLineManagerId"
												placeholder={t("text_select_5th_line_manager")}
												label={t("text_5th_line_manager")}
												valueKey="id"
												dataSource={fifthLineManagers}
												allowClear={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputText
												label={t("text_position")}
												name="position"
												placeholder={t("text_position_placeholder")}
											/>
										</Col>
										<Col lg={6}>
											<SelectInput
												name="jobGradeId"
												placeholder={t("text_select_job_grade")}
												label={t("text_job_grade")}
												valueKey="id"
												dataSource={jobGrades}
												allowClear={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="step"
												placeholder={t("text_select_step")}
												label={t("text_step")}
												valueKey="id"
												dataSource={Array.from(Array(9).keys()).map(value => ({ id: value + 1, label: value + 1 }))}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="jobLevelId"
												placeholder={t("text_select_job_level")}
												label={t("text_job_level")}
												valueKey="id"
												dataSource={jobLavels}
												allowClear={true}
											/>
										</Col>
										<Col lg={6}>
											<InputDate
												name="joinDate"
												placeholder={t("text_dd_mm_yyyy")}
												style={{ width: "100%" }}
												format="DD/MM/YYYY"
												label={t("text_date_of_employment")}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<InputDate
												name="probationExpiredDate"
												placeholder={t("text_dd_mm_yyyy")}
												style={{ width: "100%" }}
												format="DD/MM/YYYY"
												required={false}
												label={t("text_probation_expired_date")}
												disabledDate={current => current <= moment(this.props.form.getFieldValue("joinDate"))}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="employeeType"
												placeholder={t("text_select_employee_type")}
												label={t("text_employee_type")}
												valueKey="id"
												allowClear={false}
												required={true}
												dataSource={[
													{ id: "NATIONAL", name: "National" },
													{ id: "INTERNATIONAL", name: "International" }
												]}
											/>
										</Col>
										<Col lg={6}>
											<SelectInput
												name="typeOfWorker"
												placeholder={t("text_select_type_of_worker")}
												label={t("text_type_of_worker")}
												valueKey="id"
												required={true}
												allowClear={false}
												dataSource={[
													{ id: "RESIDENT", name: "Resident" },
													{ id: "NON-RESIDENT", name: "Non-Resident" }
												]}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="teamId"
												label={t("text_team")}
												placeholder={t("text_select_team")}
												valueKey="id"
												dataSource={teams}
												allowClear={true}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="departmentId"
												placeholder={t("text_select_department_programme")}
												label={t("text_department_programme")}
												valueKey="id"
												dataSource={departments}
												allowClear={true}
											/>
										</Col>
										<Col lg={6}>
											<SelectInput
												name="dutyStation"
												placeholder={t("text_select_duty_station")}
												label={t("text_duty_station")}
												valueKey="name"
												allowClear={true}
												dataSource={dutyStations}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="contractType"
												onChange={this.onChangeContractType}
												label={t("text_contract_type")}
												placeholder={t("text_select_contract_type")}
												required={true}
												errorMessage={"Please select contract type!"}
												valueKey="id"
												dataSource={[
													{ id: Enum.CONTRACT_TYPE.UDC, name: t("text_udc") },
													{ id: Enum.CONTRACT_TYPE.FDC, name: t("text_fdc") },
													{ id: Enum.CONTRACT_TYPE.VOLUNTEER, name: t("text_volunteer") },
													{ id: Enum.CONTRACT_TYPE.CONSULTANT, name: t("text_consultant") },
													{ id: Enum.CONTRACT_TYPE.INTERNSHIP, name: t("text_internship") },
												]}
											/>
										</Col>
										<Col lg={6} offset={2}>
											<SelectInput
												name="workingDay"
												initialValue="MTOF"
												placeholder={t("text_select_working_day")}
												label={t("text_working_day")}
												required={true}
												allowClear={true}
												valueKey="id"
												dataSource={[
													{ id: "MTOF", name: "Working day (M-F)" },
													{ id: "OPERATION_CALENDAR", name: "Operations Calendar" }
												]}
											/>
										</Col>

										<Col lg={6}>
											<SelectInput
												name="roleId"
												label={t("text_role")}
												placeholder={t("text_select_role_component")}
												required={true}
												errorMessage={t("text_please_select_role")}
												valueKey="id"
												dataSource={roles}
											/>
										</Col>

										<Col lg={6} offset={2}>
											<SelectInput
												name="status"
												label={t("text_employment_status")}
												placeholder={t("text_select_employment_status")}
												defaultValue={1}
												onChange={this.onChangeStatus}
												valueKey="id"
												allowClear={true}
												dataSource={[
													{ id: 1, name: t("text_active") },
													{ id: 0, name: t("text_inactive") },
													{ id: 4, name: "Maternity Leave" },
													{ id: 5, name: "Sicking Leave" }
												]}
											/>
										</Col>

										<Col lg={6} offset={2} id="contract-end-date" style={{ display: "none" }}>
											<InputDate
												name="contractEndDate"
												required={requiredContractEndDate ? requiredContractEndDate : false}
												errorMessage={t("text_please_select_contract_end_date")}
												placeholder={t("text_dd_mm_yyyy")}
												style={{ width: "100%" }}
												format="DD/MM/YYYY"
												allowClear={false}
												label={t("text_contract_end_date")}
											/>
										</Col>
										<Col lg={6} offset={requiredContractEndDate ? 0 : 2} id="last-working-day" style={{ display: "none" }}>
											<InputDate
												id="last-working-day"
												name="lastWorkingDay"
												errorMessage={t("text_please_select_last_working_day")}
												required={requiredLastWorkingDay ? requiredLastWorkingDay : false}
												placeholder={t("text_dd_mm_yyyy")}
												format="DD/MM/YYYY"
												allowClear={false}
												label={t("text_last_working_day")}
												disabledDate={current => current <= moment(this.props.form.getFieldValue("joinDate"))}
												style={{ width: "100%" }}
											/>
										</Col>

										{/* <Col lg={24}>
											<NumberInput
												name="numberOfWorkDayPayroll"
												defaultValue={0}
												label={t("text_number_of_working_day")}
												placeholder={t("text_enter_number_of_working_day")}
												isAutoSelect={true}
											/>
											
										</Col> */}
										
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_denors_budget_allocation")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col lg={24}>
											<div style={{ marginBottom: 25 }}>
												<Table
													rowKey={() => `budgetAllocations${Date.now() + Math.random()}`}
													style={{ marginTop: 15 }}
													dataSource={budgetAllocations}
													columns={[
														{
															title: t("text_project_name_code"),
															dataIndex: "project",
															key: "project",
															render: (project, record, index) => {
																return (
																	<SelectInput
																		placeholder={t("text_project_name_code")}
																		style={{ marginBottom: 0 }}
																		valueKey="name"
																		onChange={(value) => this.onChangeBudgetAllocation(value, index, "project")}
																		defaultValue={project}
																		isAutoSelect={true}
																		allowClear={true}
																		dataSource={projects}
																	/>
																);
															}
														},
														{
															title: t("text_project_code"),
															dataIndex: "subProject",
															key: "subProject",
															render: (subProject) => subProject
														},
														{
															title: t("text_sub_project_code"),
															dataIndex: "subProjectCode",
															key: "subProjectCode",
															render: (subProjectCode, record, index) => {
																					const subProjectCodes = record.payload ? record.payload : [];
																					return <SelectInput
																							placeholder={t("text_sub_project_code")}
																							style={{marginBottom: 0}}
																							valueKey="subProject"
																							nameKey="subProject"
																							onChange={(subProjectCode) => this.onChangeSubProjectCode(subProjectCode, subProjectCodes, index)}
																							defaultValue={subProjectCode}
																							isAutoSelect={true}
																							allowClear={true}
																							dataSource={subProjectCodes}
																					/>
															}
													},
														{
															title: t("text_percentage_of_allocate"),
															dataIndex: "percentage",
															key: "percentage",
															width: 200,
															render: (percentage, record, index) => {
																return (
																	<NumberInput
																		defaultValue={percentage}
																		placeholder={t("text_enter_percentage_of_allocate")}
																		style={{ marginBottom: 0 }}
																		max={100}
																		onChange={(value) => this.onChangeBudgetAllocation(value, index, "percentage")}
																		isAutoSelect={true}
																	/>
																);
															}
														},
														{
															title: t("text_action"),
															dataIndex: "id",
															key: "id",
															width: 160,
															align: "center",
															render: (id, record, index) => {
																return (
																	<div style={{
																		fontSize: 23,
																		color: "red"
																	}}>
																		<CloseOutlined onClick={() => this.onRemoveButtton(index, "budgetAllocations")} />
																	</div>
																);
															},
														},
													]}
													pagination={false}
													footer={() =>
														<Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => this.onNewButton("budgetAllocations", ["project", "percentage", "subProject"])}>
															{t("text_add_new")}
														</Button>
													}
												/>
											</div>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", margin: 0 }}>{t("text_contract_termination_notice_period")}</p>
											<Divider style={{ margin: "6px 0px 25px 0px" }} />
										</Col>
										<Col span={6} >
											<SelectInput
												name="isNoticeTerminate"
												label={t("text_notice_of_termination")}
												errorMessage={"Please select yes/no!"}
												onChange={this.onChangeNoticeTerminate}
												allowClear={true}
												valueKey="id"
												placeholder={t("text_select_yes_no")}
												dataSource={[
													{ id: 1, name: "Yes" },
													{ id: 0, name: "No" },
												]}
											/>
										</Col>
										{
											this.props.form.getFieldValue("isNoticeTerminate") === 1 &&
											<Col lg={6} offset={2}>
												<InputDate
													name="noticeTerminateAt"
													placeholder={t("text_dd_mm_yyyy")}
													required={true}
													style={{ width: "100%" }}
													format="DD/MM/YYYY"
													label={t("text_notice_termination_at")}
													errorMessage="Notice termination at is required"
												/>
											</Col>
										}
										<Col span={8} offset={2} id={"notice-period-type"} style={{ display: "none" }}>
											<Row >
												<Col span={14}>
													<SelectInput
														name="noticePeriodType"
														label={t("text_short_absent_notice_period")}
														valueKey="id"
														required={requiredNoticePeriodType}
														errorMessage={"Please select notice period!"}
														onChange={this.onChangeNoticePeriodType}
														placeholder={t("text_select_notice_period")}
														dataSource={[
															{ id: "2WEEK", name: "2 weeks" },
															{ id: "1MONTH", name: "1 month" },
															{ id: "2MONTH", name: "2 months" },
															{ id: "3MONTH", name: "3 months" },
															{ id: "CUSTOM", name: "Customize" },
														]}
													/>
												</Col>
												<Col span={9} offset={1} id="notice-period-type-working-day" style={{ display: "none" }}>
													<NumberInput
														label={"  "}
														name={"noticePayload"}
														placeholder={t("text_working_day")}
														isAutoSelect={true}
													/>
												</Col>
											</Row>
										</Col>
										<Col span={6} offset={!requiredNoticePeriodType && 2}>
											<SelectInput
												name="terminationBenefit"
												label={t("text_termination_benefit")}
												valueKey="id"
												allowClear={true}
												placeholder={t("text_select_yes_no")}
												dataSource={[
													{ id: 1, name: "Yes" },
													{ id: 0, name: "No" },
												]}
											/>
										</Col>
									</Row>
								</Card>
								<Card title={t("text_compensation_benefit")} bordered={false} className="employee-form" style={{ marginBottom: 25 }} id="profile-4">
									<Row gutter={25}>
										<Col lg={6}>
											<NumberInput
												label={t("text_basic_salary")}
												name="basicSalary"
												placeholder={t("text_basic_salary")}
												required={true}
												precision={2}
											/>
										</Col>
										<Col lg={7} offset={2}>
											<Row>
												<Col span={14}>
													<NumberInput
														label={t("text_pension_fund")}
														name="pensionFund"
														placeholder={t("text_pension_fund")}
														precision={2}
													/>
												</Col>
												<Col span={9} offset={1}>
													<SelectInput
														name="pensionFundType"
														label={"  "}
														valueKey="id"
														allowClear={true}
														placeholder={"Type"}
														initialValue="PERCENTAGE"
														dataSource={[
															{ id: "AMOUNT", name: "Amount" },
															{ id: "PERCENTAGE", name: "Percentage" },
														]}
													/>

												</Col>
											</Row>
										</Col>
										<Col lg={7} offset={2}>
											<Row>
												<Col span={14}>
													<NumberInput
														label={t("text_providend_fund")}
														name="providentFund"
														placeholder={t("text_providend_fund")}
														precision={2}
													/>
												</Col>
												<Col span={9} offset={1}>
													<SelectInput
														name="providentFundType"
														label={"  "}
														valueKey="id"
														placeholder={"Type"}
														allowClear={true}
														initialValue="PERCENTAGE"
														dataSource={[
															{ id: "AMOUNT", name: "Amount" },
															{ id: "PERCENTAGE", name: "Percentage" },
														]}
													/>

												</Col>
											</Row>
										</Col>
										<Col span={6}>
											<SelectInput
												name="insurance"
												label={t("text_insurance")}
												mode="multiple"
												valueKey="id"
												placeholder={"Select insurance"}
												dataSource={[
													{ id: "ACCIDENT", name: "Accident" },
													{ id: "HEALTH", name: "Health" },
													{ id: "LIFE", name: "Life" },
												]}
											/>
										</Col>
										<Col span={7} offset={2}>
											<SelectInput
												name="annualSalary"
												label={"13th Month Salary"}
												placeholder={"Please select"}
												valueKey="id"
												allowClear={true}
												initialValue={1}
												dataSource={[
													{ id: 1, name: "Yes" },
													{ id: 0, name: "No" },
												]}
											/>
										</Col>
										<Col span={7} offset={2}>
											<SelectInput
												name="seniority_severancePay"
												label={"Seniority/Severance Pay"}
												valueKey="id"
												allowClear={true}
												placeholder={"Please select"}
												dataSource={[
													{ id: "SENIORITY", name: "Seniority" },
													{ id: "SEVERANCEPAY", name: "Severance Pay" },
												]}
											/>
										</Col>
										<Col lg={24}>
											<Table
												rowKey={() => `benifits${Date.now() + Math.random()}`}
												style={{ marginTop: 15 }}
												dataSource={this.fixedEmployeeBenefits.concat(employeeBenefits)}
												columns={[
													{
														title: t("text_benefit"),
														dataIndex: "payrollItemId",
														key: "payrollItemId",
														render: (payrollItemId, record, index) => {
															if (record.fix) {
																return record.title;
															} else {
																return <SelectInput
																	style={{ marginBottom: 0 }}
																	defaultValue={payrollItemId}
																	placeholder={t("text_select_benifit")}
																	allowClear={true}
																	onChange={(_, option) => this.onChangeBenifit(option, index - 3, "code")}
																	valueKey="payrollItemId"
																	required={true}
																	dataSource={payrollItems}
																/>
															}
														}
													},
													{
														title: t("text_amount"),
														dataIndex: "amount",
														key: "amount",
														render: (amount, record, index) => {
															return <NumberInput
																style={{ margin: 0 }}
																placeholder={t("text_enter_amount")}
																onChange={record.fix ? (value) => this.onChangeBenifitFix(value, index, "amount") : (value) => this.onChangeBenifit(value, index - 3, "amount", record)}
																defaultValue={Math.abs(amount)}
																precision={2}
																isAutoSelect={true}
															/>
														}
													},
													{
														title: "Fringe Benefit Tax",
														dataIndex: "isTaxable",
														key: "isTaxable",
														align: "center",
														render: (isTaxable, record, index) => {
															return <Checkbox
																defaultChecked={isTaxable}
																onChange={record.fix ? (event) => this.onChangeBenifitFix(event.target.checked, index, "isTaxable") : (event) => this.onChangeBenifit(event.target.checked, index - 3, "isTaxable")}
															/>
														}
													},
													{
														title: t("text_offered_tax_by"),
														dataIndex: "offeredBy",
														key: "offeredBy",
														render: (offeredBy, record, index) => {
															return <SelectInput
																style={{ marginBottom: 0 }}
																placeholder={t("text_select_benifit")}
																valueKey="id"
																required={true}
																allowClear={true}
																defaultValue={offeredBy ? offeredBy : "ORGANIZATION"}
																onChange={record.fix ? (value) => this.onChangeBenifitFix(value, index, "offeredBy") : (value) => this.onChangeBenifit(value, index - 3, "offeredBy")}
																dataSource={[
																	{ id: "ORGANIZATION", name: "Organization" },
																	{ id: "EMPLOYEE", name: "Employee" },
																]}
															/>
														}
													},
													{
														title: t("text_action"),
														dataIndex: "action",
														key: "action",
														width: 160,
														align: "center",
														render: (id, record, index) => {
															if (!record.fix) {
																return (
																	<div style={{
																		fontSize: 23,
																		color: "red"
																	}}>
																		<CloseOutlined onClick={() => this.onRemoveButtton(index - 3, "employeeBenefits")} />
																	</div>
																);
															}
														},
													},
												]}
												pagination={false}
												footer={() =>
													<Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => this.onNewButton("employeeBenefits", ["payrollItemId", "code", "amount", "isTaxable", "offeredBy"])}>
														{t("text_add_new")}
													</Button>
												}
											/>
										</Col>
										<Col lg={24} style={{ marginTop: 15 }}>
											<p style={{ fontSize: 14, fontWeight: "bold", marginBottom: 15 }}>{t("text_attachment_of_benefit_information")}</p>
										</Col>
										<Col lg={24}>
											<div id="employee-upload-file">
												<Dragger
													customRequest={(options) => this.onUploadFile(options, "benefitFiles", "upload_benefit")}
													multiple={true}
													onRemove={(file) => this.onRemoveFile(file, "benefitFiles", "delete_benefit?path=benefits")}
													fileList={benefitFiles}
												>
													<p className="ant-upload-drag-icon">
														<PaperClipOutlined style={{ fontSize: 35 }} />
													</p>
													<p className="ant-upload-text" style={{ fontSize: 16, fontWeight: 400, color: "#000000", letterpacing: "-0.38px" }}>Click or drag file to this area to upload</p>
													<p className="ant-upload-hint">
														Support for a single upload. Strictly prohibit from uploading like insurance or other benefit files
													</p>
												</Dragger>
											</div>
										</Col>
									</Row>
								</Card>
							</div>
						</Form>
						:
						<Result
							status="403"
							title="403"
							subTitle={t("text_sorry_you_are_not_authorized_to_access_this_page")}
						/>
				}
			</>


		);
	}
}

const EmployeeCreate = () => {
	const navigate = useNavigate();
	const [form] = Form.useForm();
	return <CreateNew navigate={navigate} form={form} />;
}
export default EmployeeCreate;
